module.exports = __webpack_public_path__ + "img/desktop/Background/intro_background@3x.jpg?1.0.17";